export const DURATION = {
  toast: 5000
};
